/**
 * Colores de la línea y los nodos de avance del tracking de cortes.
 */
export enum TipoColorLineaAvanceEnum {
  /**
   * Línea de progreso del corte imprevisto.
   */
  IMPREVISTO = '#CB0126',
  /**
   * Línea cuando el corte está normalizado.
   */
  NORMALIZADO = '#0B9D65',
  /**
   * Línea del corte programado.
   */
  PROGRAMADO = '#FFCD1E',
  /**
   * Tramos y nodos que aún no se alcanzan.
   */
  PENDIENTE = '#CCCFDB',
  /**
   * Línea del corte futuro.
   */
  FUTURO = '#0285BF',
}
